var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-header-bar"},[_c('div',{staticClass:"title-header-bar-word"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('img',{attrs:{"src":require("../../../static/images/common/title-bar.jpg")}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2325de0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/title-bar.vue
// module id = null
// module chunks = 